<template>
   <div class="role-page" v-rect-loading="loading">
    <div class="role-header">
      <div class="role-title">{{ titleLabel }}</div>
    </div>
    <div class="transfer-container">
      <div class="transfer-head">{{ transferHead }}</div>
        <el-transfer
          class="transfer"
          v-model="selectedRoles"
          :data="data"
          :titles="[this.$t(`${i18nPrefix}.label.roleSource`), this.$t(`${i18nPrefix}.label.roleTarget`)]"
          />
      <div class="bottom-btn-group">
        <el-button class="cancel-btn" @click="handleCancel">{{ cancelBtnLabel }}</el-button>
        <el-button class="save-btn" @click="handleSave">{{ saveBtnLabel }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import { addI18nProperty, selectLabelI18n } from '@/i18n'
import { mixedRouterPush } from '@/router/routes'

export default {
  data () {
    return {
      i18nPrefix: 'admin.company.userManagement',
      data: [],
      loading: false,
      selectedRoles: [],
      company: null,
      account: null
    }
  },
  computed: {
    accountId () {
      return this.$route.params.accountId
    },
    cancelBtnLabel () {
      return selectLabelI18n(this, 'cancelBtn', 'common.btn.cancel')
    },
    saveBtnLabel () {
      return selectLabelI18n(this, 'saveBtn', 'common.btn.save')
    },
    titleLabel () {
      return this.$t(`${this.i18nPrefix}.title.roleManagement`)
    },
    transferHead () {
      if (this.company) {
        addI18nProperty(this.company, 'company_name', 'cn_name', 'name')
        return this.$t(`${this.i18nPrefix}.label.roleHead`, { name: this.account.full_name, company: this.company.company_name, email: this.account.email_address })
      } else {
        return ''
      }
    }
  },
  created () {
    this.queryCompany = this.$route.query.company
    this.initDate()
  },
  mounted () {},
  methods: {
    ...mapActions('userManagement', ['getRole', 'updateRole', 'getUser']),
    async initDate () {
      this.loading = true
      try {
        await Promise.all([
          this.loadUserData(),
          this.loadUserRole()
        ])
      } finally {
        this.loading = false
      }
    },
    async loadUserData () {
      const params = {
        account_id: this.accountId
      }
      const resp = await this.getUser(params)
      this.account = resp
    },
    async loadUserRole () {
      const params = {
        account_id: this.accountId
      }
      const resp = await this.getRole(params)
      if (resp) {
        const data = _.map(resp.all_roles, role => {
          return {
            key: role.id,
            label: role.title
          }
        })
        this.data = data
        this.company = resp.company
        this.selectedRoles = resp.selected_roles
      }
    },
    handleCancel () {
      const backUrl = this.$route.query.back
      if (backUrl) {
        mixedRouterPush(this.$route.query.back)
      } else {
        this.$router.go(-1)
      }
    },
    async handleSave () {
      if (this.loading) {
        return
      }
      const data = {
        account_id: this.accountId,
        selected_role_ids: this.selectedRoles
      }
      try {
        this.loading = true
        const resp = await this.updateRole(data)
        if (resp) {
          this.$message({
            message: this.$t(`${this.i18nPrefix}.message.optionSuccess`),
            type: 'success'
          })
          this.$router.replace({ path: '/v-admin/user/management/list', query: { company: this.queryCompany, order: '-updated_time', keywords: this.$route.query.keywords } })
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.role-page {

  .role-header {
    display: flex;
    border-bottom: 1px solid #e4e7ed;

    .role-title {
      padding-top: 4px;
      padding-bottom: 18px;
      line-height: 25px;
      font-size: 18px;
      font-weight: 500;
      color: #303133;
    }
  }

  .transfer-container {
    max-width: 1020px;
    margin: 30px auto 0;

    .transfer {
      display: inline-block;

      ::v-deep {

        .el-transfer__buttons {
          padding: 0 25px;
        }

        .el-transfer-panel {
          width: 415px;
        }

        .el-transfer-panel__body {
          height: 460px;
        }

        .el-transfer-panel__list {
          height: 460px;
        }
      }
    }

    .transfer-head {
      text-align: left;
      font-size: 13px;
      margin-bottom: 10px;
      border-bottom: 1px solid #ddd;
      padding-bottom: 8px;
      color: #777;
    }

  }

  .bottom-btn-group {
    display: flex;
    justify-content: center;
    margin-top: 30px;

    .el-button {
      padding: 8px 28px;
      border-radius: 2px;
      line-height: 22px;
      font-size: 16px;
      font-weight: 500;
      color: #0096cc;

      &:last-child {
        margin-left: 24px;
        margin-right: 0;
        background: #0096cc;
        border-color: #0096cc;
        color: #ffffff;
      }
    }
  }
}
</style>
